<div class="notice-wr w-full mt-1" [ngClass]="noticeClass" [attr.data-testid]="dataTestId">

  <div class="notice-description flex items-center gap-3">
    @if (icon) {
      <i class="icon" [ngClass]="icon"></i>
    }
    <div class="notice-content">
      @if (title) {
        <h3 class="notice-title text-sm">{{ title }}</h3>
      }
      @if (parsedWysiwygContent) {
        <quill-view
          class="notice-rich-text"
          [content]="parsedWysiwygContent"
          format="object"
          theme="snow"></quill-view>
      } @else if (message) {
        <p class="text-sm whitespace-pre-line">{{ message }}</p>
      }
    </div>
  </div>

  <div class="notice-actions flex items-center gap-2 shrink-0">
    @if (showDismissButton) {
      <button type="button" class="btn text-btn text-sm uppercase" (click)="onDismiss()">{{ dismissLabel }}</button>
    }

    @if (showConfirmButton) {
      <button type="button" class="btn outline-btn" [disabled]="confirmDisabled"(click)="onConfirm()">{{ confirmLabel }}</button>
    }
  </div>
</div>
